import { render, staticRenderFns } from "./ConfirmBookingModal.vue?vue&type=template&id=4b89455a&scoped=true"
import script from "./ConfirmBookingModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmBookingModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89455a",
  null
  
)

export default component.exports